import { useState, type FormEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { Search } from 'lucide-react'
import { supabase } from '@/lib/supabase'

export default function CekStatusPesanan() {
  const navigate = useNavigate()
  const [nomor, setNomor] = useState('')
  const [loading, setLoading] = useState(false)
  const [notFound, setNotFound] = useState(false)

  async function handleCek(e: FormEvent) {
    e.preventDefault()
    const q = nomor.trim().toUpperCase()
    if (!q) return

    setLoading(true)
    setNotFound(false)

    const { data } = await supabase
      .from('orders')
      .select('id')
      .eq('nomor_order', q)
      .single()

    setLoading(false)

    if (data) {
      navigate(`/status?order_id=${data.id}`)
    } else {
      setNotFound(true)
    }
  }

  return (
    <div className="max-w-lg mx-auto px-4 py-12">
      <h1 className="text-xl font-bold text-gray-900 mb-1">Cek Status Pesanan</h1>
      <p className="text-sm text-gray-400 mb-8">
        Masukkan nomor transaksi yang kamu terima setelah order.
      </p>

      <form onSubmit={handleCek} className="flex flex-col gap-3">
        <div className="relative">
          <input
            type="text"
            value={nomor}
            onChange={e => { setNomor(e.target.value.toUpperCase()); setNotFound(false) }}
            placeholder="Masukkan nomor pesanan yang diawali 'TRX' "
            className="w-full border border-gray-300 rounded-xl px-4 py-3 text-sm font-mono tracking-wide focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent uppercase"
          />
        </div>

        {notFound && (
          <p className="text-xs text-red-500">
            Nomor transaksi tidak ditemukan. Pastikan penulisannya benar.
          </p>
        )}

        <button
          type="submit"
          disabled={!nomor.trim() || loading}
          className={`flex items-center justify-center gap-2 w-full py-3 rounded-xl font-semibold text-sm transition-colors ${
            !nomor.trim() || loading
              ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
              : 'bg-blue-600 text-white hover:bg-blue-700'
          }`}
        >
          <Search size={16} />
          {loading ? 'Mencari...' : 'Cek Status'}
        </button>
      </form>
    </div>
  )
}
